import { render, staticRenderFns } from "./Residuos.vue?vue&type=template&id=6284dd76&scoped=true"
import script from "./Residuos.vue?vue&type=script&lang=js"
export * from "./Residuos.vue?vue&type=script&lang=js"
import style0 from "./Residuos.vue?vue&type=style&index=0&id=6284dd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284dd76",
  null
  
)

export default component.exports